import {ParsedUrlQuery} from 'querystring';

import {PaymentMethod, PaymentMethodType, ProfilePageQuery} from '#apollo/schema';

import AccountTab from './components/AccountTab/AccountTab';
import ManagePlanTab from './components/ManagePlanTab/ManagePlanTab';
import NotificationTab from './components/NotificationTab/NotificationTab';
import PrivacyTab from './components/PrivacyTab/PrivacyTab';
import SubscriptionTab from './components/SubscriptionTab/SubscriptionTab';

export const tabMapper = {
  subscription: SubscriptionTab,
  profile: AccountTab,
  notifications: NotificationTab,
  privacy: PrivacyTab,
  manage: ManagePlanTab,
};
export const handleRenderTabs = (tab: keyof typeof tabMapper) => {
  return tabMapper[tab];
};

export const parseQueryParams = (query: ParsedUrlQuery) => {
  const shouldSendUpdatePaymentEmail =
    ((query.updatepayment as string) || '').toLowerCase() === 'true';

  return {
    shouldSendUpdatePaymentEmail,
  };
};

export const parseProfilePageQuery = (
  data: ProfilePageQuery | undefined,
): {
  paymentMethod?: Partial<PaymentMethod>;
  paymentMethodType?: PaymentMethodType;
} => {
  if (!data) {
    return {};
  }
  const {me} = data ?? {};
  const {customerAccount} = me ?? {};
  const {subscription, paymentMethods} = customerAccount ?? {};
  const {paymentMethodId} = subscription ?? {};
  const paymentMethod = paymentMethods?.find(method => method.id === paymentMethodId);
  const paymentMethodType = paymentMethod?.type;
  return {
    paymentMethod,
    paymentMethodType,
  };
};
